const additionalServiceBed = document.querySelector(
  "[data-js='additionalServiceBed']"
);
const additionalServiceBedInput = document.querySelector(
  "#f-additional-service-bed"
);
const additionalServiceBedInputAmount = document.getElementById("bed_linen");
const additionalServiceBedSubmit = document.querySelector(
  "#submit-additional-service-bed"
);
const additionalServiceBedReset = document.querySelector(
  "#reset-additional-service-bed"
);

const asBedSubsBtn = document.querySelector("#as-bed-subs-btn");
const asBedAddBtn = document.querySelector("#as-bed-add-btn");
const asBedCountEl = document.querySelector("#as-bed-count");

let asCount = 0;

if (additionalServiceBed) {
  if (additionalServiceBedInputAmount.value > 0) {
    asCount = parseInt(additionalServiceBedInputAmount.value);
    updateCountValues();
  }
  additionalServiceBedSubmit.addEventListener("click", function () {
    let asValues = $("input[type='checkbox']:checked")
      .map(function () {
        return $(this).val();
      })
      .get()
      .join(", ");

    if (asValues != 0) {
      additionalServiceBedInput.value = asValues;
    } else if (asCount != 0) {
      additionalServiceBedInput.value = asCount + " x Bettwäsche";
    }

    if (asValues != 0 && asCount != 0) {
      additionalServiceBedInput.value =
        asValues + ", " + asCount + " x Bettwäsche";
    } else if (asValues == 0 && asCount == 0) {
      additionalServiceBedInput.value = "";
    }
    additionalServiceBedInputAmount.value = asCount;
    var bookingForm = document.getElementById("booking-form");
    formData = new FormData(bookingForm);
    const data = JSON.stringify(Object.fromEntries(formData.entries()));
    console.log(data);
    bookingForm.submit();
  });

  additionalServiceBedReset.addEventListener("click", function () {
    $("input[type='checkbox']:checked").prop("checked", false);
    asCount = 0;
    updateCountValues();
    additionalServiceBedInput.value = "";
  });

  updateCountValues();

  asBedAddBtn.addEventListener("click", function () {
    asCount = addValues(asCount);
    updateCountValues();
  });
  asBedSubsBtn.addEventListener("click", function () {
    asCount = substractValues(asCount, 0);
    updateCountValues();
  });

  function addValues(count) {
    return count + 1;
  }

  function substractValues(count, min) {
    return count > min ? count - 1 : count;
  }

  function updateCountValues() {
    asBedCountEl.innerHTML = asCount;
    if (asCount == 0) {
      asBedSubsBtn.classList.add("disabled");
    } else {
      asBedSubsBtn.classList.remove("disabled");
    }
  }
}
